import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from "@angular/router";
import {ViewSettingService} from "./view-setting.service";
import {Injectable} from "@angular/core";
import {isNullOrUndefined} from "util";

@Injectable()
export class ViewSettingResolver implements Resolve<any> {

  constructor(private viewSettingService: ViewSettingService,
              private router: Router) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // if (isNullOrUndefined(localStorage.getItem('currentUser'))) {
    //   const alias = localStorage.getItem("organizationAlias");
    //   this.router.navigate([alias + '/login'],
    //     {queryParams: {returnUrl: state.url}});
    //   return null;
    // }
    await this.viewSettingService.getSettings()
      .then((data) => {
        // console.log("timezone", JSON.stringify(data.timezone));
        // console.log("view", JSON.stringify(data.viewSettings));

        // return window.sessionStorage.setItem('view-setting', JSON.stringify(data));
      });
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/main-page/view-setting-service/view-setting.resolver.ts